import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { OilSupply } from "../../../models/oil-supply.model";
import { amount, id, text } from "../../form/controls";
import { unitOf } from "../../form/quantities";

export const OIL_CIRCUITS = [
    { key: "hyd", label: "HYD" },
    { key: "mgb", label: "MGB" },
    { key: "tgb", label: "TGB" },
    { key: "engine1", label: "ENG 1" },
    { key: "engine2", label: "ENG 2" },
] as const;

function oilRow(supply: OilSupply | null, units: string[]) {
    return new FormGroup({
        id: id(supply?.id ?? null),
        ...(Object.fromEntries(
            OIL_CIRCUITS.flatMap((circuit) => [
                [circuit.key, amount(supply?.[circuit.key]?.value ?? null)],
                [`${circuit.key}Unit`, text(unitOf(supply?.[circuit.key]?.unit ?? null) ?? units[0] ?? null)],
            ]),
        ) as Record<string, FormControl<number | string | null>>),
    });
}

/** A flight without an oil supply still offers one, empty, to log it. */
export function buildOilArray(supplies: OilSupply[], units: string[]) {
    return new FormArray((supplies.length ? supplies : [null]).map((supply) => oilRow(supply, units)));
}

export type OilArray = ReturnType<typeof buildOilArray>;

/** An oil circuit without a quantity has no unit either, so an empty row stays empty. */
export function oilUnitsOf(row: Record<string, unknown>): Record<string, unknown> {
    const units: Record<string, unknown> = { ...row };
    for (const circuit of OIL_CIRCUITS) if (row[circuit.key] === null || row[circuit.key] === undefined) units[`${circuit.key}Unit`] = null;
    return units;
}
